import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import Cookies from "js-cookie";
import { startGuestSession } from "frontend/utils/guestSession.js";
import "./Landing.scss";

const Landing = ({ onGuestStart }) => {
  const [isStarting, setIsStarting] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const history = useHistory();

  // Easy only. A first-time visitor has no basis to choose a difficulty, and
  // anyone who wants Hard can pick it from the sidebar's New Game menu.
  const startGame = async () => {
    setIsStarting(true);
    setErrorMessage("");

    try {
      await startGuestSession();
      onGuestStart();

      const response = await fetch("/api/v1/games", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${Cookies.get("access_token")}`
        },
        body: JSON.stringify({ ai_difficulty: "easy" })
      });

      const json = await response.json();

      if (!response.ok || !json.game) {
        throw new Error(json.message || "Could not start the game.");
      }

      history.push(`/games/${json.game.id}`);
    } catch (error) {
      setErrorMessage(error.message);
      setIsStarting(false);
    }
  };

  return (
    <div className="landing">
      <h1 className="landing-title">King of 20</h1>
      <p className="landing-tagline">
        Build math expressions that land as close to 20 as you can. Lowest score wins.
      </p>
      <p className="landing-modes">
        Free to play against the computer or your friends.
      </p>

      {/* Login lives in the navbar. The sidebar normally holds the rules link,
          but it is hidden for anonymous visitors, so How to Play lives here --
          styled to match the sidebar control it stands in for. */}
      <div className="landing-actions">
        <button
          className="landing-play-btn"
          onClick={startGame}
          disabled={isStarting}
        >
          {isStarting ? "Starting…" : "Play now"}
        </button>
        <Link className="landing-how-to-btn" to="/games/how-to-play">
          <span className="landing-how-to-icon">?</span>
          How to Play
        </Link>
      </div>

      <p className="landing-note">No signup needed.</p>

      {errorMessage && <p className="landing-error">{errorMessage}</p>}
    </div>
  );
};

export default Landing;
